import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import * as DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {CmsService} from '../../shared/service/cms.service';
import {Subscription} from 'rxjs';
import {HomeCarouselItemsModel} from '../../shared/models/home-carousel-items.model';
import {AuthService} from '../../shared/service';

@Component({
  selector: 'app-technical-description-page',
  templateUrl: './technical-description-page.component.html',
  styleUrls: ['./technical-description-page.component.scss']
})
export class TechnicalDescriptionPageComponent implements OnInit, OnDestroy {

  content: string = "Műszaki tartalom";
  subscriptions: Subscription[] = [];
  isLoggedIn: boolean = false;

  constructor(private cmsService: CmsService, private authService: AuthService) {

    this.subscriptions.push(this.cmsService.technicalDescriptionContent.subscribe((aboutContent: string) => {
      if(aboutContent){
        this.content = aboutContent;
      }
    }));


    this.authService.token.subscribe(
      (token) => {
        this.isLoggedIn = !!token;
      }
    );

    this.cmsService.getTechnicalDescriptionContent()


  }

  ngOnInit() {
  }

  onContentSaved(content) {

    this.cmsService.saveTechnicalDescriptionContent(content).subscribe((response) => {
      this.cmsService.technicalDescriptionContentSubject.next(content);
    });

  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

}
